import React, { Component } from "react";
import { Col, Form } from "react-bootstrap";
import { getLocalstorage } from "../../helper";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnText: "EDIT",
      status: true,
      errors: {}
    };
  }

  render() {
    const user = getLocalstorage("user");
    const { status } = this.state;
    return (
      <div className="user-form-container">
        <div className="profile-form">
          <div className="form-heading">
            <h3>Profile</h3>
          </div>
          <div className="form-container">
            <Form>
              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={user && user.name}
                    disabled={status}
                  />
                </Form.Group>

                <Form.Group as={Col}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={user && user.email}
                    disabled={status}
                  />
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>Mobile Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={user && user.mobileNumber}
                    disabled={status}
                  />
                </Form.Group>

                {user && user.alternateMobileNumber ? (
                  <Form.Group as={Col}>
                    <Form.Label>Alternate Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      value={user && user.alternateMobileNumber}
                      disabled={true}
                    />
                  </Form.Group>
                ) : null}

                <Form.Group as={Col}>
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    type="text"
                    value={user && user.designation}
                    disabled={status}
                  />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Organization/Group</Form.Label>
                  <Form.Control
                    type="text"
                    value={user && user.organization}
                    disabled={status}
                  />
                </Form.Group>
                {/* <Form.Group as={Col}>
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    type="text"
                    value={user && user.address}
                    disabled={status}
                  />
                </Form.Group> */}
              </Form.Row>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
